import { useContext } from 'react';
import { TradicionalGroupsChartsDataContext } from '../contexts/TradicionalGroupsChartsDataContext';

export const useTradicionalGroupsChartsDataContext = () => {
    return useContext(TradicionalGroupsChartsDataContext);
};
